interface IntuitEmailNotVerifiedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function IntuitEmailNotVerifiedModal({ isOpen, onClose }: IntuitEmailNotVerifiedModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md transform rounded-lg bg-white p-6 shadow-xl transition-all">
          {/* Header */}
          <div className="mb-4">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100">
                <svg
                  className="h-6 w-6 text-amber-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900">Email Verification Required</h3>
            </div>
          </div>

          {/* Content */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-4">
              Your Intuit account email has not been verified. Intuit requires a verified email
              address to use their services.
            </p>

            <p className="text-sm text-gray-600">
              Please verify your email address in your{' '}
              <a
                href="https://accounts.intuit.com/app/account-manager/security"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-500 underline font-medium"
              >
                Intuit account settings
              </a>{' '}
              and try signing in again.
            </p>
          </div>

          {/* Actions */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
